import { downgradeComponent } from "@angular/upgrade/static";
import { RouteConfigHelperProvider } from "@app/services/routeConfigHelper.provider";
import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";
import "angular-web-notification";
import { SideNavigationService } from "src/app/main/navigation/sideNavigation.service";
import "../components/messaging/messaging.module";
import { ModuleNavigationComponent } from "./moduleNavigation/moduleNavigation.component";
import { SiteSearchComponent } from "./site-search/site-search.component";
import { SiteNavigationComponent } from "./siteNavigation/siteNavigation.component";

export class Config {
    static $inject = ["$stateProvider", "routeConfigHelperProvider"];

    constructor(
        private $stateProvider: StateProvider,
        private routeConfigHelperProvider: RouteConfigHelperProvider) {

        $stateProvider.state("app.sitesearch", {
            url: "/search",
            views: { "content@app": { component: "siteSearch" } },
            data: { title: "Search your account", subtitle: "Search across all your Vehicles, Drivers and Geofences" }
        });
    }
}

angular
    .module("app.navigation", ["angular-web-notification", "app.components.messaging"])
    .config(Config)

    .directive("siteSearch", downgradeComponent({ component: SiteSearchComponent }))
    .component("moduleNavigation", new ModuleNavigationComponent)
    .component("siteNavigation", new SiteNavigationComponent)

    .service("sideNavigationService", SideNavigationService);
